import { createSignal } from 'solid-js'

/**
 * Monthly run-effort target from the synced profile, mirrored into Solid so the
 * effort bar chart can draw its guide. The legacy app layer owns the value.
 */
const [targetMonthlyRunEffort, setTargetMonthlyRunEffortSignal] = createSignal<
   number | null
>(null)

/**
 * Applies the profile's monthly run-effort target pushed from the legacy app layer.
 *
 * @param value - The target, or null when unset.
 */
export function applyRunEffortTargetFromLegacy(value: number | null) {
   setTargetMonthlyRunEffortSignal(
      typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : null,
   )
}

export { targetMonthlyRunEffort }
